import axios from "axios";
import Swal from "sweetalert2";

/**
 * Looks for another purchase from the same supplier with the same invoice number.
 * Returns the existing purchase ({ purchaseid, billno, invoicedate, netamount }) or null.
 * Network errors return null so a failed check never blocks saving.
 */
export async function findDuplicateSupplierInvoice(vendor, invoiceno, purchaseid = null) {
  const code = String(invoiceno || "").trim();
  if (!vendor || !code) return null;
  try {
    const { data } = await axios.get("/v1/purchases/invoice-check", {
      params: { vendor, invoiceno: code, purchaseid: purchaseid || undefined },
    });
    return data?.exists ? data : null;
  } catch (error) {
    console.error("Supplier invoice check failed:", error);
    return null;
  }
}

export function duplicateInvoiceMessage(duplicate) {
  if (!duplicate) return "";
  const date = duplicate.invoicedate ? ` dated ${new Date(duplicate.invoicedate).toLocaleDateString("en-IN")}` : "";
  return `This invoice number is already entered for this supplier on purchase ${duplicate.billno || duplicate.purchaseid}${date}.`;
}

/** Asks before saving a duplicate. Resolves true when there is no duplicate or the user confirms. */
export async function confirmIfDuplicateInvoice(vendor, invoiceno, purchaseid = null) {
  const duplicate = await findDuplicateSupplierInvoice(vendor, invoiceno, purchaseid);
  if (!duplicate) return true;
  const result = await Swal.fire({
    icon: "warning",
    title: "Duplicate supplier invoice?",
    text: `${duplicateInvoiceMessage(duplicate)} Save this purchase anyway?`,
    showCancelButton: true,
    confirmButtonText: "Save anyway",
    cancelButtonText: "Go back",
    reverseButtons: true,
  });
  return result.isConfirmed;
}
